type LanguageSwitchTargetResolver = (lang: string, country: string) => Promise<string | null> | string | null;

const listeners = new Set<LanguageSwitchTargetResolver>();

export const useLangSwitchBus = () => {
    const emitLangSwitch = async (lang: string, country: string) => {
        for (const callback of listeners) {
            const target = await callback(lang, country);
            if (target) return target;
        }
        return null;
    };

    const onLangSwitch = (callback: LanguageSwitchTargetResolver) => {
        listeners.add(callback);

        return () => {
            listeners.delete(callback);
        };
    };

    return { emitLangSwitch, onLangSwitch };
};
